export var isFormSubmitting = function isFormSubmitting(formState) {
  return formState.submitting;
};
export var isFormInvalid = function isFormInvalid(formState) {
  var hasValidationErrors = formState.hasValidationErrors,
    hasSubmitErrors = formState.hasSubmitErrors,
    modifiedSinceLastSubmit = formState.modifiedSinceLastSubmit;
  return hasValidationErrors || hasSubmitErrors && !modifiedSinceLastSubmit;
};
export var shouldDisableSubmitButton = function shouldDisableSubmitButton(formState) {
  return isFormSubmitting(formState) || isFormInvalid(formState);
};